var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHatSchoolBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 81.818,
    viewBox: "0 0 100 81.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "school_FILL0_wght400_GRAD0_opsz48",
    d: "M51.886,87.818,18.932,69.75V42.477L2,33.273,51.886,6,102,33.273V69.3H95.182V37.25L84.841,42.477V69.75Zm0-35,35.8-19.545-35.8-19.2-35.568,19.2Zm0,27.273L78.023,65.659V46.568L51.886,60.545,25.75,46.341V65.659ZM52,52.818ZM51.886,61.227ZM51.886,61.227Z",
    transform: "translate(-2 -6)",
    fill: "#1c2d57"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatSchoolBlue);
export default __webpack_public_path__ + "static/media/hatSchoolBlue.ddc9fe45f0b4f5ebbb5b7cd49963f205.svg";
export { ForwardRef as ReactComponent };